<template>
  <v-container style="padding-top: 0;">
    <v-card class="shadow-small custom-scroll" style="border-radius:10px">
      <v-card-title class="px-7"> Detalle de orden: </v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text
        class="px-7"
        style="max-height: 600px; overflow-y: auto; overflow-x: hidden;"
        v-if="!loadingCartItems"
      >
        <v-row v-if="cartItems.items && cartItems.items.length > 0">
          <v-col
            v-for="(item, index) in cartItems.items"
            :key="index"
            cols="12"
            class="py-1"
          >
            <v-row class="align-center">
              <v-col cols="3" class="py-0 pl-0">
                <img
                  v-if="item.b2b_publication.product.images[0] == null"
                  :aspect-ratio="4 / 3"
                  height="86"
                  width="100%"
                  contain
                  src="../../../assets/no_image.jpg"
                  alt="noImage"
                />
                <v-img
                  v-else
                  height="86"
                  :lazy-src="item.b2b_publication.product.images[0]"
                  :src="item.b2b_publication.product.images[0]"
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
              <v-col cols="8">
                <div class="name-item-order mb-2">
                  {{ item.b2b_publication.keywords }}
                </div>
                <!--<v-slider
                  step="1"
                  min="0"
                  :max="item.b2b_publication.purchase_options.length -1"
                  thumb-label="always"
                  v-model="stepQuantityList[index]"
                  tick-size="2"
                  ticks="always"
                  color="#6400D2"
                  track-color="rgba(100, 0, 210, 0.35)"
                  class="small-slider"
                  readonly
                >
                  <template v-slot:thumb-label="{}">
                    {{item.quantity}}
                  </template>
                </v-slider>-->
                <v-row class="pl-3">
                  <div class="detail-text2">Unidad:</div>
                  <div class="amount-text2">
                    ${{ item.pvc | number_format }}
                  </div>
                </v-row>
                <v-row class="pl-3">
                  <div class="detail-text2">Cantidad:</div>
                  <div class="amount-text2">{{ item.quantity }}</div>
                </v-row>
                <v-row class="pl-3">
                  <div class="detail-text2">Subtotal:</div>
                  <div class="amount-text2">
                    ${{ (item.pvc * item.quantity) | number_format }} + IVA ({{
                      item.iva
                    }}%)
                  </div>
                </v-row>
              </v-col>
              <v-col
                cols="1"
                class="d-flex flex-column justify-center align-center px-0 py-0"
              >
                <v-btn
                  class="ml-2"
                  icon
                  color="rgba(0, 0, 0, 0.56)"
                  dark
                  @click="handlerDeleteItem(item)"
                  :loading="loadingByIndex === item.id"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-else justify="center">
          <v-col cols="12" md="9" class="d-flex justify-center">
            <p class="text-center py-10 font-weight-medium">
              No hay articulos agregados al carrito
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-else>
        <v-row>
          <v-col class="mx-auto">
            <looping-rhombuses-spinner
              class="mx-auto"
              :animation-duration="2500"
              :rhombus-size="80"
              color="#402DCE"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider class="mx-4"></v-divider>
      <v-col class="px-6">
        <div class="d-flex flex-row justify-space-between">
          <div class="detail-text">Subtotal neto:</div>
          <div class="detail-text">
            ${{
              (cartItems.total_amount - cartItems.total_iva) | number_format
            }}
          </div>
        </div>
        <div class="d-flex flex-row justify-space-between">
          <div class="detail-text">Total IVA:</div>
          <div class="detail-text">
            ${{ cartItems.total_iva | number_format }}
          </div>
        </div>
        <div class="d-flex flex-row justify-space-between">
          <div class="detail-text">Total:</div>
          <div class="detail-text">
            ${{ cartItems.total_amount | number_format }}
          </div>
        </div>
        <v-col class="d-flex flex-row justify-center">
          <v-btn
            class="outline-btn mr-3"
            @click="openCancel = true"
            :disabled="
              !!loadingByIndex ||
                loadingCartItems ||
                (cartItems.items && !cartItems.items.length > 0)
            "
          >
            CANCELAR
          </v-btn>
          <v-btn
            class="blue-btn"
            @click="goToDetails"
            :disabled="
              !!loadingByIndex ||
                loadingCartItems ||
                (cartItems.items && !cartItems.items.length > 0)
            "
          >
            CONFIRMAR
          </v-btn>
        </v-col>
      </v-col>
    </v-card>
    <simpleModal
      :active="openCancel"
      :action="handlerCancelOrder"
      :closeModal="() => (openCancel = false)"
      title="¿Estás seguro?"
      text="Al cancelar, todos los productos en la orden de compra serán eliminados."
      :loading="!!loadingByIndex"
    />
  </v-container>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment";
import simpleModal from "../modals/simpleModal.vue";
import { LoopingRhombusesSpinner } from "epic-spinners";

export default {
  components: {
    simpleModal,
    LoopingRhombusesSpinner,
  },

  props: [
    "addProductoArray",
    "getTotal",
    "getIva",
    "discount_client",
    "shopping_cart_id",
  ],

  data() {
    return {
      loading: false,
      loadingByIndex: null,
      active: false,
      value: 0,
      data: {},
      stepQuantityList: [0],
      openCancel: false,
    };
  },

  computed: {
    cartItems() {
      const items = this.$store.getters["shoppingCart/GET_CART_ITEMS"];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return items;
    },

    loadingCartItems() {
      return this.$store.getters["shoppingCart/GET_LOADING_CART_ITEMS"];
    },
  },

  filters: {
    number_format(
      value,
      decimals = 2,
      separatorThousands = ".",
      separatorDecimals = ","
    ) {
      let number = parseFloat(value);
      if (!isFinite(number) || (!number && number !== 0)) return "";
      let [integer, decimal] = Math.abs(number)
        .toFixed(decimals)
        .split(".");
      let length = integer.length;
      while (length > 3) {
        length -= 3;
        integer =
          integer.slice(0, length) + separatorThousands + integer.slice(length);
      }
      let sign = number < 0 ? "-" : "";
      return `${sign}${integer}${separatorDecimals}${decimal}`;
    },
  },

  methods: {
    async handlerCancelOrder() {
      this.loadingByIndex = -1;
      try {
        const request = {
          shopping_cart_id: this.cartItems.id,
        };
        await this.$store.dispatch("shoppingCart/EMPTY_CART", request);
        this.getShoppingCart();
      } catch (error) {
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      } finally {
        this.loadingByIndex = null;
        this.openCancel = false;
      }
    },

    async handlerDeleteItem(item) {
      this.loadingByIndex = item.id;
      try {
        const request = {
          item_id: item.id,
        };
        await this.$store.dispatch("shoppingCart/DELETE_PRODUCT_CART", request);
        this.getShoppingCart();
      } catch (error) {
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      } finally {
        this.loadingByIndex = null;
      }
    },

    async getShoppingCart() {
      try {
        await this.$store.dispatch("shoppingCart/GET_SHOPPING_CART");
      } catch (error) {
        Swal.fire({
          title: "Un error ha ocurrido",
          text: "Tenemos problemas para obtener su carrito intente mas tarde",
          icon: "error",
          confirmButtonColor: "#7160ec",
        });
      }
    },

    goToDetails() {
      this.$router.push({
        name: "details_order",
      });
    },

    PVC(item) {
      let discount_product = this.Discount(
        item.pvc,
        item.discount,
        item.selectItem
      );

      let total_pvc_product = item.pvc - discount_product;

      return total_pvc_product - total_pvc_product * (this.itemsDiscount / 100);
    },

    PVP(pvp, pvp_without_iva) {
      return pvp == null ? 0 : pvp * (pvp_without_iva / 100);
    },

    HandlerDeleteSelectedItem(item) {
      this.$emit("dialog:change", item);
    },

    confirm(item) {
      this.active = true;
      let arrayProducts = [];

      for (let index = 0; index < item.length; index++) {
        arrayProducts[index] = {
          stock_text: item[index].stock_text,
          sku: item[index].sku,
          quantity: item[index].selectItem,
          title: item[index].title,
          pvc: item[index].pvc,
          discount: item[index].discount,
          iva: item[index].iva,
          post_id: item[index].id,
        };
      }
      this.value = 1;
      // SE ENVIA products para que se pueda iterar en el simple table
      // Se envia originalProducts para poder mantener los valores originales de los productos y no afectar el funcionamiento
      this.data = {
        products: [...arrayProducts],
        // total: this.getTotal,
        total: this.getTotal,
        total_client: item.sub_pvc,
        total_discount: this.discount_client,
        originalProducts: [...item],
      };
    },

    async checkShoppingCart() {
      try {
        this.loading = true;

        const request = {
          shopping_cart_id: this.shopping_cart_id,
        };

        const response = await this.$store.dispatch(
          "shoppingCart/CHECK_SHOOPING_CART",
          request
        );
        const dueDate = response.data.data.due_date;
        this.loading = false;

        Swal.fire({
          title: "Gracias por su Pedido!",
          text: `Su pedido vence el (${moment(dueDate)
            .locale("es")
            .format(
              "DD/MM/YYYY"
            )}) y el stock se confirma el momento de facturacion`,
          icon: "success",
          confirmButtonColor: "#7160ec",
        }).then((result) => {
          if (result.value) {
            this.$router.push({ name: "dashboard" });
          }
        });
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    Discount(pvc, discount, slider_product) {
      let pvc_total = 0;
      if (slider_product > 0) {
        pvc_total = pvc * (discount / 100);
      }
      return pvc_total;
    },
    eventdialog(message) {
      if (typeof message == "object") {
        this.checkShoppingCart(message.originalProducts);
        this.active = false;
      }
      this.active = false;
    },
  },
};
</script>

<style>
.font-text-12 {
  font-size: 12px;
}
.small-slider {
  width: 70%;
}
.small-slider .v-slider__thumb-label {
  height: 16px !important;
  width: 16px !important;
  font-size: 0.52rem !important;
  transform: translateY(-20%) translateY(-9px) translateX(-50%) rotate(45deg) !important;
}
.small-slider .v-input__slot {
  margin-bottom: 0 !important;
}
.small-slider .v-messages {
  display: none !important;
}
.small-slider .v-slider__track-container {
  height: 4px !important;
}
.small-slider .v-slider__thumb {
  cursor: pointer !important;
}
.small-slider span {
  font-size: 10px;
}
.name-item-order {
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
}
.blue-btn {
  height: 42px !important;
  background-color: #343ec4 !important;
  color: white !important;
  font-size: 13px !important;
}
.outline-btn {
  height: 42px !important;
  background-color: white !important;
  color: #343ec4 !important;
  border: solid 1px #343ec4;
  font-size: 13px !important;
}
.detail-text {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 6px;
  margin-top: 6px;
}
.custom-scroll ::-webkit-scrollbar {
  width: 7px;
}
.custom-scroll ::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}
.custom-scroll ::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}
.custom-scroll ::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
